import FiltersUserVaultComponent from "../components/filters/FiltersUserVaultComponent";
import UserVaultGrid from "../components/vault/UserVaultGrid";
import React, {useEffect, useState} from "react";
import CloseIcon from "@mui/icons-material/Close";
import DetailsView from "./ViewAdDetails";
import {Typography} from "@mui/material";

const UserVaultView = ({isSidebarOpen, setSidebarOpen, newRow}) => {

    /*  INIT VARS   */

    const [queryStringObject, setQueryStringObject] = useState({});
    /**
     * Flag que indica si se muestra o no la tarjeta de detalles.
     */
    const [showDetails, setShowDetails] = useState(false);
    /**
     * Contiene el item seleccionado para mostrar su detalle.
     */
    const [itemSelectedDetail, setItemSelectedDetail] = useState({});
    /**
     * Flag que indica si mostrar el div que muestra que no hay mas anuncios para obtener
     */
    const [showContainerNoMoreData, setShowContainerNoMoreData] = useState(false);
    /**
     * Flag que indica si se va a realizar un nuevo request
     */
    const [isLoadingData, setIsLoadingData] = useState(false);

    /*  END VARS    */

    useEffect(() => {
        if (showDetails && isSidebarOpen) {
            setShowDetails(false);
        }
    }, [isSidebarOpen]);

    return (
        <div style={{display: "flex"}}>
            <div className={"search-view-container-filters-grid"}>
                <FiltersUserVaultComponent setQueryStringObject={setQueryStringObject}
                                           isLoadingData={isLoadingData}/>
                <div className={"search-view-container-grid"}>
                    {
                        <UserVaultGrid setShowDetails={setShowDetails}
                                       showDetails={showDetails}
                                       setItemSelectedDetail={setItemSelectedDetail}
                                       setSidebarOpen={setSidebarOpen}
                                       setShowContainerNoMoreData={setShowContainerNoMoreData}
                                       queryStringObject={queryStringObject}
                                       setQueryStringObject={setQueryStringObject}
                                       setIsLoadingData={setIsLoadingData}
                                       newRow={newRow}/>
                    }
                    {
                        showContainerNoMoreData && (
                            <div className={"search-container-no-more-data"}>
                                <Typography color="textSecondary" variant="h6">
                                    No hay más anuncios para mostrar.
                                </Typography>
                            </div>
                        )
                    }
                </div>
            </div>
            {
                showDetails && (
                    <div className={'detail-sticky'} style={{marginTop: "112px"}}>
                        <div className={'grid-details-close-layout'}>
                            <CloseIcon className={'grid-details-close-btn'}
                                       onClick={(e) => setShowDetails(false)}
                                       sx={{
                                           width: '38px',
                                           height: '38px',
                                           color: 'white',
                                           padding: '4px',
                                           borderRadius: '50%',
                                           borderWidth: '0.5px',
                                           borderStyle: 'solid',
                                           borderColor: 'rgba(255,255,255,0.18)'
                                       }}
                            />
                        </div>
                        <div className={'grid-details-main'}>
                            <div className={'grid-details'}>
                                <DetailsView
                                    item={itemSelectedDetail} isVault={true}
                                />
                            </div>
                        </div>
                    </div>
                )}
        </div>
    );
}

export default UserVaultView;